var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M17.383 295.703 L 17.383 382.617 104.297 382.617 L 191.211 382.617 191.211 295.703 L 191.211 208.789 104.297 208.789 L 17.383 208.789 17.383 295.703 ",
    stroke: "none",
    fill: "#04acf4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M17.383 104.297 L 17.383 191.211 104.297 191.211 L 191.211 191.211 191.211 104.297 L 191.211 17.383 104.297 17.383 L 17.383 17.383 17.383 104.297 ",
    stroke: "none",
    fill: "#f45424",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M0.000 200.000 L 0.000 400.000 200.000 400.000 L 400.000 400.000 400.000 200.000 L 400.000 0.000 200.000 0.000 L 0.000 0.000 0.000 200.000 M191.211 104.297 L 191.211 191.211 104.297 191.211 L 17.383 191.211 17.383 104.297 L 17.383 17.383 104.297 17.383 L 191.211 17.383 191.211 104.297 M382.617 104.297 L 382.617 191.211 295.703 191.211 L 208.789 191.211 208.789 104.297 L 208.789 17.383 295.703 17.383 L 382.617 17.383 382.617 104.297 M191.211 295.703 L 191.211 382.617 104.297 382.617 L 17.383 382.617 17.383 295.703 L 17.383 208.789 104.297 208.789 L 191.211 208.789 191.211 295.703 M382.617 295.703 L 382.617 382.617 295.703 382.617 L 208.789 382.617 208.789 295.703 L 208.789 208.789 295.703 208.789 L 382.617 208.789 382.617 295.703 ",
    stroke: "none",
    fill: "#f3f3f3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M208.789 295.703 L 208.789 382.617 295.703 382.617 L 382.617 382.617 382.617 295.703 L 382.617 208.789 295.703 208.789 L 208.789 208.789 208.789 295.703 ",
    stroke: "none",
    fill: "#fcbc04",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M208.789 104.297 L 208.789 191.211 295.703 191.211 L 382.617 191.211 382.617 104.297 L 382.617 17.383 295.703 17.383 L 208.789 17.383 208.789 104.297 ",
    stroke: "none",
    fill: "#84bc04",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMicrosoft);
export default __webpack_public_path__ + "static/media/logo_microsoft.edd3df45a84bd8bb19728ac710b51a95.svg";
export { ForwardRef as ReactComponent };